// Multivariate Dependencies
import React from 'react';
// Components
import { Icon } from '../../Icon';
import { Container } from '../../../common/styles/container';
export var IconBadgeStructure = function (_a) {
    var icon = _a.icon, className = _a.className, ariaLabel = _a.ariaLabel;
    return (React.createElement(Container, { className: className },
        React.createElement(Icon, { name: icon, ariaLabel: ariaLabel })));
};
//# sourceMappingURL=IconBadgeStructure.js.map